export default __webpack_public_path__ + "static/media/home-img-1.7ce8e24e.png";